import { Component, OnInit } from '@angular/core';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { dateStringFromISO8601 } from '../../../../../../utils';

import { AccountService } from '../../../../../../services/account/account.service';
import { UnlinkedEntryPassCustomerInboxItem } from '../../../../../../models/inbox';
import { InboxService } from '../../../../../../services/inbox/inbox.service';
import {
  ReviewUnlinkedEntryPassCustomerModalComponent
} from './modals/review-unlinked-entry-pass-customer-modal/review-unlinked-entry-pass-customer-modal.component';

@Component({
  selector: 'app-inbox-unlinked-entry-passes',
  templateUrl: './inbox-unlinked-entry-passes.component.html',
  styleUrls: ['./inbox-unlinked-entry-passes.component.css']
})
export class InboxUnlinkedEntryPassesComponent implements OnInit {

  public unlinkedEntryPassCustomers: UnlinkedEntryPassCustomerInboxItem[];

  public loadingUnlinkedEntryPassCustomers = false;

  public serverError: number = null;

  // Create instance references to lookup functions and enums so they may be
  // called in the template.
  public dateStringFromISO8601 = dateStringFromISO8601;

  constructor(
    public accountService: AccountService,
    private inboxService: InboxService,
    private modalService: NgbModal
  ) {}

  ngOnInit() {
    if (!this.accountService.getMyAccount().can_manage_members) {
      return;
    }

    this.loadUnlinkedEntryPassCustomers();
  }

  public unlinkedEntryPassesPresent() {
    return this.unlinkedEntryPassCustomers && (this.unlinkedEntryPassCustomers.length > 0);
  }

  public openReviewUnlinkedEntryPassCustomerModal(unlinkedEntryPassCustomer: UnlinkedEntryPassCustomerInboxItem) {
    const modalRef = this.modalService.open(ReviewUnlinkedEntryPassCustomerModalComponent);
    modalRef.componentInstance.unlinkedCustomerInboxItem = unlinkedEntryPassCustomer;
    modalRef.componentInstance.savedCallback = () => {
      this.loadUnlinkedEntryPassCustomers();
    };
  }

  private loadUnlinkedEntryPassCustomers() {
    this.loadingUnlinkedEntryPassCustomers = true;

    this.inboxService
      .getUnlinkedEntryPassCustomers()
      .then(unlinkedEntryPassCustomers => {
        this.unlinkedEntryPassCustomers = unlinkedEntryPassCustomers;
      })
      .catch(reason => {
        if (reason.status === 403) {
          this.accountService.logout();
        } else {
          this.serverError = reason.status;
        }
      })
      .finally(() => { this.loadingUnlinkedEntryPassCustomers = false; });
  }

}
